export function parsePxValue(value: string | number | undefined): number {
  if (!value) {
    return 0;
  }

  if (typeof value === 'string') {
    return parseInt(value.replace('px', '')) || 0;
  }
  return value;
}
